<template>
  <div>
    <Modal title="Jenkins" v-model="showModal" @on-cancel="$refs.editForm.resetFields()">
      <Alert v-if="infoError" type="warning" show-icon>获取数据失败</Alert>
      <Form :model="editForm" ref="editForm" :label-width="75" :rules="editRules" v-else>
        <FormItem label="名称" prop="name">
          <Input v-model="editForm.name" :maxlength="100" placeholder="Jenkins名称（别名）" />
        </FormItem>
        <FormItem label="URL" prop="url">
          <Input v-model="editForm.url" placeholder="Jenkins服务器URL地址" />
        </FormItem>
        <FormItem label="用户名" prop="username">
          <Input v-model="editForm.username" :maxlength="64" placeholder="登录用户名" />
        </FormItem>
        <FormItem label="Token" prop="token">
          <Input v-model="editForm.token" :maxlength="128" placeholder="连接Token" type="password" />
        </FormItem>
        <FormItem label="权限用户" prop="allow_user">
          <Select v-model="editForm.allow_user" placeholder="可操作此Jenkins的用户" clearable filterable multiple>
            <Option v-for="item in userList" :key="item.id" :value="item.id">{{ item.name ? item.name : item.username }}</Option>
          </Select>
        </FormItem>
        <FormItem label="权限用户组" prop="allow_user_group">
          <Select v-model="editForm.allow_user_group" placeholder="可操作此Jenkins的用户组" clearable filterable multiple>
            <Option v-for="item in groupList" :key="item.id" :value="item.id" :label="item.name"></Option>
          </Select>
        </FormItem>
      </Form>
      <div slot="footer">
        <Button type="primary" @click="submit" :loading="submitting" :disabled="infoError">提交</Button>
        <Button @click="showModal = false; $refs.editForm.resetFields()" style="margin-left: 8px">取消</Button>
      </div>
    </Modal>
  </div>
</template>

<script>
import { changeJenkins, detailJenkins } from '@/api/tools/jenkins'
import { GetALLUsers, getAllGroup } from '@/api/user'

export default {
  data () {
    return {
      showModal: false,
      submitting: false,
      infoError: false,
      editForm: {
        id: '',
        name: '',
        url: '',
        username: '',
        token: '',
        allow_user: [],
        allow_user_group: []
      },
      editRules: {
        name: { required: true, message: '名称不能为空', trigger: 'blur' },
        url: { required: true, message: 'URL不能为空', trigger: 'blur' },
        username: { required: true, message: '用户名不能为空', trigger: 'blur' },
        token: { required: true, message: 'Token不能为空', trigger: 'blur' }
      },
      userList: [],
      groupList: []
    }
  },
  created: function () {
    this.getAllUserData()
    this.getAllGroupData()
  },
  methods: {
    openModal (id) {
      this.infoError = false
      if (id) {
        detailJenkins(id).then(res => {
          for (let i in this.editForm) {
            this.editForm[i] = res.data[i]
          }
          this.showModal = true
        }).catch(res => {
          this.infoError = true
        })
      } else {
        this.editForm = {
          id: '',
          name: '',
          url: '',
          username: '',
          token: '',
          allow_user: [],
          allow_user_group: []
        }
        this.showModal = true
      }
    },
    // 获取用户列表
    getAllUserData () {
      GetALLUsers().then(res => {
        this.userList = res.data
      }).catch(res => {
        console.error(res.response)
      })
    },
    // 获取用户组列表
    getAllGroupData () {
      getAllGroup().then(res => {
        this.groupList = res.data
      }).catch(res => {
        console.error(res.response)
      })
    },
    submit () {
      this.$refs.editForm.validate((valid) => {
        if (valid) {
          this.submitting = true
          changeJenkins(this.editForm, this.editForm.id).then(res => {
            this.$Notice.success({title: '操作成功'})
            this.$emit('editComplete', this.editForm.id)
            this.showModal = false
            this.submitting = false
          }).catch(res => {
            this.submitting = false
            console.log(res.response)
            if (res.request) {
              this.$Notice.error({
                title: '操作失败！',
                desc: res.request.responseText
              })
            } else {
              this.$Notice.error({
                title: '操作失败！'
              })
            }
          })
        }
      })
    }
  }
}
</script>

<style scoped>

</style>
